import { CallAPIAction, Status } from 'api/types'
import Actions from 'redux/actions'
import { GetInterviewBillResponse } from 'api/interviewAPI'

type State = {
  file: string
  name: string
} & Status

const initialState = {
  file: '',
  name: '',
  isLoading: false,
  success: false,
  fail: false,
}

export default (
  state: State = initialState,
  action: CallAPIAction<
    Actions.GET_INTERVIEW_BILL_ASYNC,
    Actions.GET_INTERVIEW_BILL_SUCCESS,
    Actions.GET_INTERVIEW_BILL_FAIL,
    GetInterviewBillResponse
  >,
): State => {
  switch (action.type) {
    case Actions.GET_INTERVIEW_BILL_ASYNC:
    case Actions.GET_INTERVIEW_BILL_FAIL: {
      return {
        ...state,
        ...action.status,
      }
    }
    case Actions.GET_INTERVIEW_BILL_SUCCESS: {
      return {
        ...state,
        ...action.status,
        file: action.payload.bytes,
        name: action.payload.name,
      }
    }

    default:
      return state
  }
}
